export default __webpack_public_path__ + "static/media/img10.511a0434.jpg";